"use client"

import { useRouter } from "next/navigation"

interface LvrOption {
  label: string
  value: string
}

interface LvrSelectorProps {
  options: LvrOption[]
  currentValue: string
  rateType: string
  state: string
  borrowerType: string
  interestOnly: boolean
}

export default function LvrSelector({
  options,
  currentValue,
  rateType,
  state,
  borrowerType,
  interestOnly,
}: LvrSelectorProps) {
  const router = useRouter()

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // Navigate to the new URL with updated LVR parameter
    router.push(
      `/borrowing/${rateType}?state=${state}&borrowerType=${borrowerType}&interestOnly=${interestOnly}&lvr=${e.target.value}`
    )
  }

  return (
    <div className="flex items-center">
      <label htmlFor="lvr-select" className="mr-2 text-sm font-medium text-gray-700">
        LVR:
      </label>
      <select
        id="lvr-select"
        className="block w-28 rounded-md border-gray-300 py-2 pl-2 pr-8 text-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
        value={currentValue}
        onChange={handleChange}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
